import { Grid, Paper, SxProps, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

type Metric = {
	key: string
	title: string
	value: string
	query?: string
	Icon?: any
}

type CardProps = {
	activeMetric?: boolean
	metric: Metric
	handleOnClick?: (m: Metric) => void
	sx?: SxProps
}

export default function Card({ metric: { Icon, ...metric }, activeMetric, handleOnClick, sx }: CardProps) {
	const { palette } = useTheme()
	const color = useCallback(
		() => (activeMetric ? palette.primary.main : palette.text.lighter),
		[activeMetric, palette.primary.main, palette.text.lighter],
	)
	return (
		<Grid
			item
			xs={12}
			sm={6}
			md={3}
			key={metric.key}
			onClick={() => handleOnClick && handleOnClick(metric)}
			sx={sx}
		>
			<Paper
				elevation={0}
				sx={{
					padding: 2,
					textAlign: 'center',
					borderRadius: '8px',
					border: '1px solid #ccc',
				}}
			>
				<Typography
					variant="h6"
					gutterBottom
					sx={{
						color: color(),
						textAlign: 'left',
						textTransform: 'uppercase',
						fontSize: '14px',
					}}
				>
					{metric.title}
				</Typography>
				<Box display="flex" alignItems="center">
					{Icon && <Icon color={color()} />}
					<Typography
						sx={{
							color: color(),
							fontSize: '22px',
							fontFamily: '"Eczar", serif',
							fontWeight: '500',
							marginLeft: '8px',
							marginRight: 'auto',
						}}
					>
						{metric.value}
					</Typography>
				</Box>
			</Paper>
		</Grid>
	)
}
